import { render, staticRenderFns } from "./VqModal.vue?vue&type=template&id=2a1e054d&lang=html&"
import script from "./VqModal.vue?vue&type=script&lang=js&"
export * from "./VqModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports